<template>
    <div>
        <div>
            <!-- FAQs -->
            <div v-if="faqsLink" class="hamburgerHelp__item md:py-4">
                <div class="hamburgerHelp__itemLeft">
                    <img src="@/assets/images/decoration/FAQs.svg" alt="FAQs">
                </div>
                <div class="hamburgerHelp__itemRight">
                    <p>
                         {{ $t('CONTACT_US_VISIT') }}
                        <router-link :to="{ name: 'faq' }" class="link">
                            <span @click="$emit('closed')">
                                {{ $t('CONTACT_US_FAQ') }}
                            </span>
                        </router-link>
                    </p>
                </div>
            </div>
            <!-- Telephone -->
            <div class="hamburgerHelp__item md:pb-4">
                <div class="hamburgerHelp__itemLeft">
                    <img src="@/assets/images/decoration/telephone-icon.png" alt="Call">
                </div>
                <div class="hamburgerHelp__itemRight">
                    <p>
                        {{ $t('CONTACT_US_GIVE') }} <br class="sm:hidden">
                        <a class="link" :href="`tel:${contactNumber}`">{{ $t('COMPANY_TELEPHONE',{contactNumber}) }}</a>
                    </p>
                </div>
            </div>

            <!-- Email -->
            <div class="hamburgerHelp__item md:pb-4">
                <div class="hamburgerHelp__itemLeft">
                    <img src="@/assets/images/decoration/email-icon.png" alt="Email">
                </div>
                <div class="hamburgerHelp__itemRight">
                    <p>
                        {{ $t('CONTACT_US_EMAIL') }} <br class="sm:hidden">
                        <a class="link" :href="`mailto:${email}`">
                            {{ email }}
                        </a>
                    </p>
                </div>
            </div>
        </div>

        <!-- Social links -->
        <div class="px-4 my-4 flex items-center justify-center">
            <a class="mx-2" :href="$t('FACEBOOK_URL')" target="_blank">
                <img class="hamburger__socialIcon"
                     src="@/assets/images/decoration/social-icon-facebook.png"
                     alt="Facebook">
            </a>

            <a class="mx-2" :href="$t('INSTAGRAM_URL')" target="_blank">
                <img class="hamburger__socialIcon"
                     src="@/assets/images/decoration/social-icon-instagram.png"
                     alt="Instagram">
            </a>

            <a v-if="!isUSA" class="mx-2" :href="$t('TWITTER_URL')" target="_blank">
               <img class="hamburger__socialIcon"
                   src="@/assets/images/decoration/social-icon-twitter.png"
                   alt="Twitter">
            </a>
        </div>

        <!-- Other links -->
        <div class="w-full">
            <!-- Removing until after DE launch
            <div class="w-full text-center">
                <p>
                    <router-link :to="{ name: 'blog' }" class="link text-sm" target="_blank">
                        <div @click="$emit('closed')">
                            {{ $t('CONTACT_US_BLOG') }}
                        </div>
                    </router-link>
                </p>
            </div>
            <div class="w-full text-center">
                <p>
                    <router-link :to="{ name: 'jobs' }" class="link text-sm">
                        <div @click="$emit('closed')">
                            {{ $t('CONTACT_US_JOBS') }}
                        </div>
                    </router-link>
                </p>
            </div> -->
             <div class="w-full text-center" v-if="!isUSA">
                <p>
                    <router-link :to="{ name: 'jobs' }" class="link text-sm">
                        <div @click="$emit('closed')">
                            {{ $t('CONTACT_US_JOBS') }}
                        </div>
                    </router-link>
                </p>
            </div>
            <div class="w-full text-center" v-if="!isDEU">
                <p>
                    <router-link :to="{ name: 'terms-and-conditions' }" class="link text-sm">
                        <div @click="$emit('closed')">
                            {{ $t('CONTACT_US_TERMS') }}
                        </div>
                    </router-link>
                </p>
            </div>
            <div class="w-full text-center" v-if="!isDEU">
                <p>
                    <router-link :to="{ name: 'privacy-policy' }" class="link text-sm">
                        <div @click="$emit('closed')">
                            {{ $t('CONTACT_US_PRIVACY') }}
                        </div>
                    </router-link>
                </p>
            </div>
            <div class="w-full text-center" v-if="isDEU">
                <p>
                    <a href="#" class="link text-sm">
                        <div @click="showCookieBanner()">
                            {{ $t('CONTACT_US_COOKIE') }}
                        </div>
                    </a>
                </p>
            </div>
             <div class="w-full text-center" v-if="isDEU">
                <p>
                    <router-link :to="{ name: 'impressum' }" class="link text-sm">
                        <div @click="$emit('closed')">
                            {{ $t('CONTACT_US_IMPRESSUM') }}
                        </div>
                    </router-link>
                </p>
            </div>
            <div class="w-full text-center" v-if="isDEU">
               <p>
                   <router-link :to="{ name: 'payment-and-delivery' }" class="link text-sm">
                       <div @click="$emit('closed')">
                           {{ $t('CONTACT_US_PAYMENT_AND_DELIVERY') }}
                       </div>
                   </router-link>
               </p>
           </div>
           <div class="w-full text-center" v-if="isDEU">
              <p>
                  <router-link :to="{ name: 'right-to-cancel' }" class="link text-sm">
                      <div @click="$emit('closed')">
                          {{ $t('CONTACT_US_RIGHT_TO_CANCEL') }}
                      </div>
                  </router-link>
              </p>
          </div>
          <div class="w-full text-center" v-if="isDEU">
              <p>
                  <router-link :to="{ name: 'sustainability' }" class="link text-sm">
                      <div>
                          {{ $t('CONTACT_US_SUSTAINABILITY') }}
                      </div>
                  </router-link>
              </p>
          </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ContactUs',
    data() {
        return {
            email: process.env.VUE_APP_EMAIL,
            contactNumber: process.env.VUE_APP_TELEPHONE,
        };
    },
    props: {
        faqsLink: {
            required: false,
            default: false,
            type: Boolean,
        },
    },
    methods: {
        showCookieBanner() {
            this.$store.commit('cookies/showCookieBanner');
        },
    },
    computed: {
        isDEU() {
            return this.$store.getters['localisation/isDEU'];
        },
        isUSA() {
            return this.$store.getters['localisation/isUSA'];
        },
    },
};
</script>
